import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import UserActions from '../../Redux/UserRedux'
import DownloadUserList from '../../Containers/User/DownloadUserList'
import AdvancedFilter from '../../Components/AdvancedFilter'
import filterData from './filterData.json'
import { currentRole } from '../../Utils/PrivilegeUtils'

class List extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.sourceType = [
      { value: '', label: 'All' },
      { value: 'passpod', label: 'Passpod' },
      { value: 'travypass', label: 'Travypass' }
    ]
    this.state = {
      showModal: null,
      filter: {
        page: 1,
        q: '',
        type: '',
        filterDate: false,
        registration_from: null,
        registration_until: null,
        only_admins: false
      }
    }
  }

  componentDidMount = () => {
    this._fetchUser()
  }

  _fetchUser = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    if (this.state.filter.registration_from && this.state.filter.registration_until) {
      params.registration_from = this.state.filter.registration_from.format('Y-MM-DD')
      params.registration_until = this.state.filter.registration_until.format('Y-MM-DD')
    } else {
      params.registration_from = null
      params.registration_until = null
    }
    params.filterDate = null
    this.props.getUser(params)
  }

  _manipulateState = (props) => {
    this.setState({ filter: props })
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._fetchUser({ page })
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  render () {
    const { user } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              User List
              {
                (user.fetching || user.processing) &&
                <div className='badge badge-info ml-2'>{user.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              currentRole() !== 'cs' &&
              <button className='btn btn-primary' onClick={() => this._toggleModal('download-user-list')}>Download User List</button>
            }
          </div>
          <div className='title-block'>
            <AdvancedFilter
              filters={filterData.userListFilters}
              manipulateState={(props) => this._manipulateState(props)}
              callback={(event) => this._fetchUser(null, event)}
            />
          </div>
        </header>
        <section className='section' style={{ width: '150%' }}>
          <div className='card'>
            {
              !(user.fetching || user.processing) && user.err &&
              <div className='alert alert-danger'>{user.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th className='text-center'>Profile</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Country Code</th>
                    <th>Phone number</th>
                    <th>Provider</th>
                    <th>Source</th>
                    <th>Role</th>
                    <th>Total Order</th>
                    <th>Create Date</th>
                    <th>Last Login</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  {(user.data && user.data.total === 0) &&
                    <tr>
                      <td colSpan='12' className='text-center'>- No Data -</td>
                    </tr>
                  }
                  { (user.data && user.data.total !== 0) && user.data.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-center'>
                        <img src={item.profile_picture} alt='profile' width='35px' />
                      </td>
                      <td>{ item.first_name || '-' }</td>
                      <td>{ item.last_name || '-' }</td>
                      <td>{ item.email || '-' }</td>
                      <td>{ item.country_code || '-' }</td>
                      <td>{ item.phone_number || '-' }</td>
                      <td>{ item.provider_type || '-' }</td>
                      <td>{ item.type || '-' }</td>
                      <td>{ item.role || '-' }</td>
                      <td className='text-center'>{ item.count_order || '-' }</td>
                      <td>{ moment.unix(item.created_at).format(this.dateFormat) || '-' }</td>
                      <td>{ moment.unix(item.last_login).format(this.dateFormat) || '-' }</td>
                      <td>
                        <label className={`badge badge-${item.active ? 'success' : 'danger'}`}>
                          {String(item.active)}
                        </label>
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <Modal open={this.state.showModal === 'download-user-list'} onClose={this._toggleModal} closeOnOverlayClick>
          <DownloadUserList closeModal={() => this._toggleModal()} />
        </Modal>

        <section className='text-center'>
          {
            (user.data && user.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={user.data.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={user.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  user: state.user
})

const dispatchToProps = (dispatch) => ({
  getUser: (filter) => dispatch(UserActions.userRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/Pages/User/List.js